import { Text } from '@chakra-ui/react';
import { format, utcToZonedTime } from 'date-fns-tz';
import { FC } from 'react';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useUserEventTimezone } from '@/hooks/useUserEventTimezone';

interface ILectureCardDateProps {
  heldAt: string;
}

export const LectureSearchCardDate: FC<ILectureCardDateProps> = ({ heldAt }) => {
  const { timeZone, eventId } = useQueryParams<{ timeZone: string; eventId: string }>({
    timeZone: StringParam,
    eventId: StringParam,
  });

  const userEventTimezone = useUserEventTimezone(eventId);

  const zonedTime = utcToZonedTime(new Date(heldAt), timeZone || userEventTimezone);

  return (
    <Text textStyle="plexBody" fontWeight="semibold">
      {format(zonedTime, 'dd MMMM yyyy @ HH:mm')}
    </Text>
  );
};
